import { Link } from 'react-router-dom';
import { navs } from '../utils/constants';

function Menu({ isMenuOpen, toggleMenu }) {
	const closeMenu = () => {
		if (isMenuOpen) {
			toggleMenu();
		}
	};

	return (
		<div className={`Menu-container ${isMenuOpen ? '' : 'Menu-toggle'} `}>
			<ul className="Menu-lists">
				{navs.map((nav, index) => (
					<li key={index} onClick={closeMenu}>
						<Link to={nav.path}>{nav.name}</Link>
					</li>
				))}
				<li onClick={closeMenu}>
					<a
						href="https://medium.com/@julieifionu"
						target="_blank"
						rel="noreferrer"
					>
						MY BLOG
					</a>
				</li>
			</ul>
		</div>
	);
}

export default Menu;
